import { stripIndent } from 'common-tags';
import { OrderRefunded } from './components/OrderRefunded';

export const orderRefundedEmailTemplate = {
  label: 'Order Refunded',
  description: 'Sent when a customer\'s order is refunded',
  icon: 'RefundLine',
  component: OrderRefunded,
  defaultTemplate: {
    name: 'Order Refunded',
    subject: {
      en: 'Your refund for order #{{ orderNumber }} has been processed — {{ storeName }}',
      fr: 'Votre remboursement pour la commande #{{ orderNumber }} a été traité — {{ storeName }}',
      it: 'Il rimborso per l\'ordine #{{ orderNumber }} è stato elaborato — {{ storeName }}',
      es: 'Tu reembolso del pedido #{{ orderNumber }} ha sido procesado — {{ storeName }}',
      de: 'Deine Rückerstattung für Bestellung #{{ orderNumber }} wurde bearbeitet — {{ storeName }}',
    },
    templateVariables: {
      order_refunded: {
        body: {
          en: stripIndent`
            <p>Hi {{ customerFirstName }},</p>
            <p>We've processed a refund of <strong>{{ refundAmount }}</strong> for your order <strong>#{{ orderNumber }}</strong>.</p>
            <p>The refund should appear on your statement within 5–10 business days, depending on your bank.</p>
            <p>If you have any questions, please don't hesitate to contact us.</p>
          `,
          fr: stripIndent`
            <p>Bonjour {{ customerFirstName }},</p>
            <p>Nous avons traité un remboursement de <strong>{{ refundAmount }}</strong> pour votre commande <strong>#{{ orderNumber }}</strong>.</p>
            <p>Le remboursement devrait apparaître sur votre relevé sous 5 à 10 jours ouvrés, selon votre banque.</p>
            <p>Si vous avez des questions, n'hésitez pas à nous contacter.</p>
          `,
          it: stripIndent`
            <p>Ciao {{ customerFirstName }},</p>
            <p>Abbiamo elaborato un rimborso di <strong>{{ refundAmount }}</strong> per il tuo ordine <strong>#{{ orderNumber }}</strong>.</p>
            <p>Il rimborso dovrebbe apparire sul tuo estratto conto entro 5-10 giorni lavorativi, a seconda della tua banca.</p>
            <p>Se hai domande, non esitare a contattarci.</p>
          `,
          es: stripIndent`
            <p>Hola {{ customerFirstName }},</p>
            <p>Hemos procesado un reembolso de <strong>{{ refundAmount }}</strong> para tu pedido <strong>#{{ orderNumber }}</strong>.</p>
            <p>El reembolso debería aparecer en tu estado de cuenta en un plazo de 5 a 10 días hábiles, según tu banco.</p>
            <p>Si tienes alguna pregunta, no dudes en contactarnos.</p>
          `,
          de: stripIndent`
            <p>Hallo {{ customerFirstName }},</p>
            <p>Wir haben eine Rückerstattung von <strong>{{ refundAmount }}</strong> für deine Bestellung <strong>#{{ orderNumber }}</strong> verarbeitet.</p>
            <p>Die Rückerstattung sollte innerhalb von 5–10 Werktagen auf deinem Kontoauszug erscheinen, abhängig von deiner Bank.</p>
            <p>Bei Fragen kannst du uns jederzeit kontaktieren.</p>
          `,
        },
      },
    },
  },
  variables: [
    { key: 'customerFirstName', label: 'Customer First Name', example: 'John' },
    { key: 'customerLastName', label: 'Customer Last Name', example: 'Doe' },
    { key: 'customerEmail', label: 'Customer Email', example: 'john@example.com' },
    { key: 'storeName', label: 'Store Name', example: 'My Store' },
    { key: 'orderNumber', label: 'Order Number', example: '1042' },
    { key: 'refundAmount', label: 'Refund Amount', example: '$149.99' },
  ],
  utmParameters: {
    utmSource: 'order_refunded',
    utmMedium: 'email',
  },
  specificParams: undefined,
  mockData: (storeName = 'Demo Store') => ({
    store: {
      id: 'store_preview',
      name: storeName,
      baseCurrency: 'USD',
      presentmentCurrencies: ['USD'],
      chargeCurrencies: ['USD'],
    },
    customer: {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john@example.com',
      locale: 'en-US',
    },
    order: {
      id: 'ord_preview_1042',
      orderNumber: '1042',
      status: 'refunded',
      paidAt: new Date(),
      currency: 'USD',
      totalAmount: 14999,
      items: [],
      customer: { firstName: 'John', lastName: 'Doe', email: 'john@example.com', locale: 'en-US' },
      store: { id: 'store_preview', name: storeName },
    },
  }),
  defaultMessages: {
    order_title: 'Order Refunded',
    order_subtitle: 'Your refund has been processed',
    cta_button: 'View Order',
    footer_text: '© 2025 All rights reserved',
  },
};
